import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ANIMATION_FUNCTION } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { ONBOARDING_HUB_BUTTON_URL } from "app/pages/sales-intelligence/constants/images";

const collapseTransition = `all 200ms ${ANIMATION_FUNCTION}`;

export const StyledOnboardingHubContentWrapper = styled(FlexRow)`
    gap: 8px;
`;

export const StyledOnboardingHubButtonContainer = styled.div`
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.bluegrey[200]};
    transition: ${collapseTransition};
    transition-delay: 300ms;
    &.isButton {
        background: ${colorsPalettes.torquoise[50]};
        background-image: url(${ONBOARDING_HUB_BUTTON_URL});
        border: none;
    }

    opacity: 0;
    width: 16px;
    max-height: 0;
    padding: 16px 7px;
    margin-bottom: 1rem;

    &.isShowHubButton,
    &.isHubClosed {
        transition-delay: 0ms;
        width: 188px;
        padding: 12px;
    }

    &.isShowHubButton {
        opacity: 1;
        max-height: 192px;
    }

    &.isHubClosed {
        opacity: 0;
        pointer-events: none;
    }

    &.dropdownDisabled {
        box-shadow: 0 0 0 0 rgba(14, 30, 62, 0.12);
    }

    &:not(.dropdownDisabled) {
        cursor: pointer !important;

        & > * {
            cursor: pointer !important;
        }
    }

    &:not(.dropdownDisabled):hover {
        box-shadow: 5px 5px 16px 0 rgba(14, 30, 62, 0.12);
        cursor: pointer;
    }

    &:not(.dropdownDisabled):active {
        transition: box-shadow 50ms ${ANIMATION_FUNCTION};
        transition-delay: 0ms;
        box-shadow: 0px 0px 0px 0px rgba(14, 30, 62, 0.12);
        cursor: pointer;
    }
`;
